import Vue from 'vue'
import Router from 'vue-router'
//引入页面
import Index from '../pages/index.vue'
import AboutUs from '../pages/aboutUs.vue'
import Product from '../pages/product.vue'
import Service from '../pages/service.vue'
import Shop from '../pages/shop.vue'
import Policy from '../pages/policy.vue'
import Question from '../pages/question.vue'
import Download from '../pages/download.vue'
import Relation from '../pages/relation.vue'
import hR from '../pages/homeRecommand.vue'
import Productstation from '../pages/Productstation.vue'
import jointproduct from '../pages/JointProduct.vue'
import sales from '../pages/sales.vue'
import meetingShake from '../pages/meeting/meetingShake.vue'
import shakePage from '../pages/meeting/shakePage.vue'
import card from '../pages/meeting/card.vue'
import SignIn from '../pages/meeting/SignIn.vue'
import News from '../pages/News.vue'
import ProductPage from '../pages/ProductPage.vue'
Vue.use(Router)

const routes = [
	{
		path: '*',
		redirect: '/index'
	},
	{
		path: '/index',
		component: Index,
		meta: {
			title: '乐范健康科技 - 人体工学背靠·护腰坐垫品牌 | 乐班官网 | 乐范官网 | Zmind官网'
		}
	}, {
		path: '/about-us',
		component: AboutUs,
		meta: {
			title: '关于乐范 - iF设计奖人体工学品牌 | 乐班 Leband'
		}
	}, {
		path: '/product',
		component: Product,
		meta: {
			title: '产品介绍 - 人体工学背靠·护腰坐垫·小沙发 | 乐班官网'
		}
	}, {
		path: '/service',
		component: Service,
		meta: {
			title: '服务支持 - 售后政策·使用指南 | 乐班官网'
		}
	}, {
		path: '/shop',
		component: Shop,
		meta: {
			title: '官方网店 - 人体工学护腰产品购买 | 乐班 Leband'
		}
	}, {
		path: '/policy',
		component: Policy,
		meta: {
			title: '售后政策 - 退换货·保修服务 | 乐班官网'
		}
	}, {
		path: '/question',
		component: Question,
		meta: {
			title: '产品介绍视频 - 人体工学背靠·魔力贴使用教程 | 乐班'
		}
	}, {
		path: '/download',
		component: Download,
		meta: {
			title: 'App下载 - 乐范按摩器配套应用 | 乐班'
		}
	}, {
		path: '/relation',
		component: Relation,
		meta: {
			title: '联系我们 - 客服咨询·商务合作 | 乐班官网'
		}
	}, {
		path: '/hR',
		component: hR,
		meta: {
			title: '部位推荐 - 全身·腰部·肩颈按摩方案 | 乐班官网'
		}
	},
	{
		path: '/Productstation',
		component: Productstation,
		meta: {
			title: '产品详情 - 人体工学背靠·护腰产品 | 乐班官网'
		}
	},
	{
		path: '/news',
		component: News,
		meta: {
			title: '新闻资讯 - 乐范健康科技动态 | 乐班'
		}
	},
	// {
	// 	path: '/productPage',
	// 	component: ProductPage,
	// 	meta: {
	// 		title: '产品站'
	// 	}
	// },
	{
		path: '/jointproduct',
		component: jointproduct,
		meta: {
			title: '跨界联名产品 - 熊本熊·迪士尼联名 | 乐班官网'
		}
	},
	{
		path: '/sales',
		component: sales,
		meta: {
			title: '全网销量TOP5 - 人体工学护腰产品排行榜 | 乐班官网'
		}
	},
	
	{
		path: '/meetingcard',
		component: card,
		meta: {
			title: '年会抽奖'
		}
	},
	{
		path: '/meetingShake',
		component: meetingShake,
		meta: {
			title: '年会摇一摇'
		}
	},
	{
		path: '/meetingShakePage',
		component: shakePage,
		meta: {
			title: '摇一摇中奖界面'
		}
	},
	{
		path: '/meetingSignIn',
		component: SignIn,
		meta: {
			title: '签到'
		}
	}
]

export default new Router({
	routes,
	mode: 'history',
})
